<div class="vneid-content">
    <div class="scan-container" aria-hidden="true">
      <img
        [src]="data.images.cardFront"
        alt=""
        class="card-bg card-0"
      />
      <img
        [src]="data.images.cardBack"
        alt=""
        class="card-bg card-1"
      />
      <img
        [src]="data.images.faceScan"
        alt=""
        class="card-bg card-2"
      />
  
      <div class="scan-line-wrapper">
        <div class="scan-line-container">
          <img
            *ngIf="data.images.scanLine"
            [src]="data.images.scanLine"
            alt=""
            class="scan-line-glow"
          />
          <div class="laser-beam"></div>
        </div>
      </div>
    </div>
  
    <div class="text-group">
      <h3 id="vneid-modal-title" class="title-text">{{ data.title }}</h3>
      <p id="vneid-modal-description" class="desc-text">
        {{ data.description }}
      </p>
    </div>
  </div>
  